import broadbandTechSupportIconImg from "@static/img/dashboard/broadband-tech-support.svg";
import { SvgIcon } from "@mui/material";
import { useStyle } from "../style";

export const BroadbandTechSupportIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={broadbandTechSupportIconImg} inheritViewBox />;
};
